import ReactDom from 'react-dom';

import { Icon as BlueIcon } from '@blueprintjs/core';

import { Dispatch, SetStateAction } from 'react';
import { IProductCreateUpdate } from '@models/Product.model';
import {
  Container,
  Overlay,
  Close,
  Header,
  Title,
  Confirm,
  Line,
  Form,
  Divider,
  Label,
} from './Warning.styles';

interface IWarning {
  open: boolean;
  onClose: () => void;
  eventValue: any;
  setManufacturerValue: Dispatch<
    SetStateAction<{
      value: string;
      label: string;
    } | null>
  >;
  setSelectedProducts: Dispatch<SetStateAction<IProductCreateUpdate[]>>;
}

export const Warning = ({
  open,
  onClose,
  setManufacturerValue,
  eventValue,
  setSelectedProducts,
}: IWarning) => {
  const portalDiv = document.getElementById('portal');

  return open && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            <Header>
              <Title>Warning</Title>
              <Close onClick={onClose}>
                <BlueIcon icon="cross" color="#8F95B2" />
              </Close>
            </Header>

            <Divider height="28px" />

            <Label>
              As of now, updates can only be created for products from the same
              manufacturer.
              <br />
              You have selected products from this manufacturer, changing the
              manufacturer will clear the Selected Items list.
              <br />
              Do you want to proceed?
            </Label>

            <Form>
              <Line>
                <Confirm type="button" onClick={onClose} className="clear">
                  Cancel
                </Confirm>
                <Confirm
                  type="button"
                  onClick={() => {
                    setManufacturerValue(eventValue);
                    setSelectedProducts([]);
                    onClose();
                  }}
                >
                  Yes, clear list
                </Confirm>
              </Line>
            </Form>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
